const { createAction } = require("../helpers");
const {
  OTP_CODE,
  OTP_CODE_SUCCESS,
  OTP_CODE_ERROR,
  OTP_CODE_RESET,

  OTP_CODE_VERIFY,
  OTP_CODE_VERIFY_SUCCESS,
  OTP_CODE_VERIFY_ERROR,
  OTP_CODE_VERIFY_RESET,
} = require("./constants");

const otpCode = ({ type, countryCode, phoneNumber, email, recaptchaToken }) =>
  createAction(OTP_CODE, {
    type,
    countryCode,
    phoneNumber,
    email,
    recaptchaToken,
  });

const otpCodeSuccess = (sessionId) =>
  createAction(OTP_CODE_SUCCESS, { sessionId });

const otpCodeError = (error, message) =>
  createAction(OTP_CODE_ERROR, { error, message });

const otpCodeReset = () => createAction(OTP_CODE_RESET);

const otpCodeVerify = ({ sessionId, code, recaptchaToken }) =>
  createAction(OTP_CODE_VERIFY, {
    sessionId,
    code,
    recaptchaToken,
  });

const otpCodeVerifySuccess = (data) =>
  createAction(OTP_CODE_VERIFY_SUCCESS, { data });

const otpCodeVerifyError = (error, message) =>
  createAction(OTP_CODE_VERIFY_ERROR, { error, message });

const otpCodeVerifyReset = () => createAction(OTP_CODE_VERIFY_RESET);

module.exports = {
  otpCode,
  otpCodeSuccess,
  otpCodeError,
  otpCodeReset,

  otpCodeVerify,
  otpCodeVerifySuccess,
  otpCodeVerifyError,
  otpCodeVerifyReset,
};
